import qs from 'qs';
import { network } from 'services/network';

export const getFilterItemOptionsByRowType = ({ rowType }: { rowType: string }) => {
    const querystring = qs.stringify({ rowType }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getFilterItemOptionsByRowType${querystring}`;
    return network.get(url).then((response) => response.data);
};
